<template>
  <div
    class="flex items-center justify-center rounded-full select-none text-whiteOverride"
    :class="[variantClass, sizeClass]"
    data-test="indicator">
    <FontIcon
      data-test="icon"
      :name="icon"
    />
  </div>
</template>

<script>
import FontIcon from '@/components/Icon.vue';

const variants = {
  fail: 'variant-fail',
  success: 'variant-success',
  info: 'variant-info',
};
const sizes = {
  small: 'size-small',
  large: 'size-large',
  xLarge: 'size-xLarge',
};

export default {
  name: 'BaseIndicator',
  components: {
    FontIcon,
  },
  props: {
    icon: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'fail',
      validator(value) {
        return Object.keys(variants).includes(value);
      },
    },
    size: {
      type: String,
      require: false,
      default: 'large',
      validator(value) {
        return Object.keys(sizes).includes(value);
      },
    },
  },
  computed: {
    variantClass() {
      return variants[this.variant];
    },
    sizeClass() {
      return sizes[this.size];
    },
  },
};
</script>

<style scoped>

.size-xLarge {
  @apply h-fifty w-fifty text-xl min-w-fifty min-h-fifty;
}

.size-large {
  @apply h-twentyFive w-twentyFive text-base min-w-twentyFive min-h-twentyFive;
}

.size-small {
  @apply h-twenty w-twenty text-xs min-w-twenty min-h-twenty;
}

.variant-fail {
  @apply bg-envelopeStatus-cancelled;
}

.variant-success {
  @apply bg-success3;
}

.variant-info {
  @apply bg-secondaryHover;
}
</style>

